'use client';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { StaticImageData } from 'next/image';
import Link from 'next/link';

type projectCardProps = {
  i: number;
  isInternal?: boolean;
  data: {
    projectImg: StaticImageData | string;
    projectName: string;
    projectDescription: string;
    redirectlink: string;
  };
};

const ProjectCard = ({ i, data, isInternal }: projectCardProps) => {
  const [width, setWidth] = useState<number>(0);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  return (
    <Link
      prefetch={true}
      href={isInternal ? data.redirectlink : `our-work/${data.redirectlink}`}
      className="group"
    >
      <div
        className={` ${width >= 1280 ? ((i + 1) % 3 !== 2 ? 'mt-16' : '') : i % 2 === 0 ? 'md:mt-16' : ''} flex h-max flex-col gap-9`}
      >
        <div>
          <Image
            src={data?.projectImg || ''}
            alt={data?.projectName}
            width={500}
            height={500}
            loading="lazy"
            sizes="(max-width: 640px) 90vw, (max-width: 768px) 45vw, (max-width: 1024px) 30vw, 350px"
            className="aspect-[13/15] w-full rounded-[20px] brightness-75 transition-transform duration-300 ease-in group-hover:brightness-100 md:group-hover:rotate-2 md:group-hover:scale-105"
          />
        </div>

        <div className="flex flex-col gap-3">
          <h3 className="font-opt text-lg font-medium leading-6 text-white transition-all duration-300 ease-in group-hover:translate-x-2 group-hover:text-lightBlue">
            {data?.projectName}
          </h3>
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;
